import React, { FC } from 'react';
import { TouchableOpacity, View } from 'react-native';

import { COLORS } from '../../config/designSystem/Colors';
import { Caption1Bold } from '../../config/designSystem/typography';
import { SPACING } from '../../config/designSystem/Spacing';

/**
 * figma: the Summary | Calendar segmented control of the Activity Page
 * (Activities & Challenges pt1, node 9693-21682).
 */
interface SegmentedTabsProps {
  tabs: { key: string; label: string }[];
  active: string;
  onChange: (key: string) => void;
}

export const SegmentedTabs: FC<SegmentedTabsProps> = ({ tabs, active, onChange }) => {
  return (
    <View
      style={{
        flexDirection: 'row',
        backgroundColor: COLORS.surface.contrast,
        borderWidth: 1,
        borderColor: COLORS.border.secondary,
        borderRadius: SPACING['sp-12'],
        padding: 3,
      }}
    >
      {tabs.map(tab => {
        const isActive = tab.key === active;
        return (
          <TouchableOpacity
            key={tab.key}
            onPress={() => onChange(tab.key)}
            style={{
              flex: 1,
              paddingVertical: SPACING['sp-8'],
              borderRadius: SPACING['sp-8'],
              alignItems: 'center',
              backgroundColor: isActive ? COLORS.content.accent : 'transparent',
            }}
          >
            <Caption1Bold color={isActive ? COLORS.content['inverse-primary'] : COLORS.content.secondary}>
              {tab.label}
            </Caption1Bold>
          </TouchableOpacity>
        );
      })}
    </View>
  );
};
